import { css, html, TemplateResult } from "lit";
import { customElement, property } from "lit/decorators.js";
import { BaseElement } from "./base/BaseElement";

@customElement("loading-element2")
export class LoadingElement2 extends BaseElement {
  static styles = css`
    loading-element2 {
      display: flex;
      align-items: center;
      justify-content: center;

      box-sizing: border-box;
      position: absolute;
      z-index: 9999;
    }
    .loading-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
    }

    .spinner {
      width: 60px;
      height: 60px;
      /* animation: rotate 2s linear infinite; */
    }

    .spinner svg {
      width: 100%;
      height: 100%;
      display: block;
    }

    .spinner path:first-child {
      animation: dash 2s ease-in-out infinite;
      transform-origin: center;
    }

    @keyframes rotate {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

    @keyframes dash {
      0% {
        stroke-dasharray: 0 130;
        stroke-dashoffset: 0;
      }
      50% {
        stroke-dasharray: 65 65;
        stroke-dashoffset: -65;
      }
      100% {
        stroke-dasharray: 0 130;
        stroke-dashoffset: -130;
      }
    }

    .loading-text {
      font-family: "Mulish", sans-serif;
      font-size: 16px;
      font-weight: 300;
      opacity: 1;
      animation: pulse 2s ease-in-out infinite;
    }

    @keyframes pulse {
      0%,
      100% {
        opacity: 0.6;
      }
      50% {
        opacity: 1;
      }
    }

    /* Alternatif: Sadece stroke animasyonu (döndürme yok) */
    .spinner-simple {
      width: 60px;
      height: 60px;
    }
  `;

  private _resizeObserver?: ResizeObserver;

  @property({ type: String, attribute: "text" })
  private _text: string = "Yükleniyor...";

  public set text(value: string) {
    this._text = value;
    this.requestUpdate();
  }

  public get text() {
    return this._text;
  }
  connectedCallback(): void {
    super.connectedCallback();
    const host = this.getHostParent();
    if (host) {
      this._resizeObserver = new ResizeObserver(() => {
        this.style.width = host.offsetWidth + "px";
        this.style.height = host.offsetHeight + "px";
      });
      this._resizeObserver.observe(host);
      this.style.width = host.offsetWidth + "px";
      this.style.height = host.offsetHeight + "px";
    }
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this._resizeObserver?.disconnect();
  }

  protected renderHtml(): TemplateResult {
    return html`<div class="loading-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        preserveAspectRatio="xMidYMid meet"
        width="75"
        height="75"
        viewBox="0 0 500 500"
        style="width: 100%; height: 100%"
      >
        <defs>
          <animateMotion
            repeatCount="indefinite"
            dur="3s"
            begin="0s"
            xlink:href="#_R_G_L_10_G"
            fill="freeze"
            keyTimes="0;0.04;0.44;0.84;1"
            path="M8 0 C8,0 8,0 8,0 C0,0 -40,0 -40,0 C-40,0 0,0 8,0 C8,0 8,0 8,0 "
            keyPoints="0;0;0.5;1;1"
            keySplines="0.668 0 0 1;0.668 0 0 1;0.668 0 0 1;0 0 0 0"
            calcMode="spline"
          />
          <animateMotion
            repeatCount="indefinite"
            dur="3s"
            begin="0s"
            xlink:href="#_R_G_L_9_G_N_10_T_0"
            fill="freeze"
            keyTimes="0;0.4;0.8;1"
            path="M0 0 C9.8,0 59.22,0 59.22,0 C59.22,0 9,0 0,0 C0,0 0,0 0,0 "
            keyPoints="0;0.5;1;1"
            keySplines="0.668 0 0 1;0.668 0 0 1;0 0 0 0"
            calcMode="spline"
          />
          <animate
            repeatCount="indefinite"
            dur="3s"
            begin="0s"
            xlink:href="#_R_G_L_8_G_D_0_P_0"
            fill="freeze"
            attributeName="d"
            attributeType="XML"
            from="M-46.5 15.83 C-46.5,15.83 -4.26,-26.54 -4.26,-26.54 C-4.26,-26.54 48.82,26.54 48.82,26.54 "
            to="M-46.5 15.83 C-46.5,15.83 -4.26,-26.54 -4.26,-26.54 C-4.26,-26.54 48.82,26.54 48.82,26.54 "
            keyTimes="0;0.0666667;0.1333333;0.6;0.6666667;1"
            values="M-46.5 15.83 C-46.5,15.83 -4.26,-26.54 -4.26,-26.54 C-4.26,-26.54 48.82,26.54 48.82,26.54 ;M-46.5 15.83 C-46.5,15.83 -4.26,-26.54 -4.26,-26.54 C-4.26,-26.54 48.82,26.54 48.82,26.54 ;M-56.48 25.36 C-56.48,25.36 -4.26,-26.54 -4.26,-26.54 C-4.26,-26.54 48.82,26.54 48.82,26.54 ;M-56.48 25.36 C-56.48,25.36 -4.26,-26.54 -4.26,-26.54 C-4.26,-26.54 48.82,26.54 48.82,26.54 ;M-46.5 15.83 C-46.5,15.83 -4.26,-26.54 -4.26,-26.54 C-4.26,-26.54 48.82,26.54 48.82,26.54 ;M-46.5 15.83 C-46.5,15.83 -4.26,-26.54 -4.26,-26.54 C-4.26,-26.54 48.82,26.54 48.82,26.54 "
            keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
            calcMode="spline"
          />
          <animateMotion
            repeatCount="indefinite"
            dur="3s"
            begin="0s"
            xlink:href="#_R_G_L_8_G"
            fill="freeze"
            keyTimes="0;0.4;0.8;1"
            path="M142.72 149.96 C153.8,149.96 209.22,149.96 209.22,149.96 C209.22,149.96 153.8,149.96 142.72,149.96 C142.72,149.96 142.72,149.96 142.72,149.96 "
            keyPoints="0;0.5;1;1"
            keySplines="0.668 0 0 1;0.668 0 0 1;0 0 0 0"
            calcMode="spline"
          />
          <animate
            repeatCount="indefinite"
            dur="3s"
            begin="0s"
            xlink:href="#_R_G_L_6_G_D_0_P_0"
            fill="freeze"
            attributeName="d"
            attributeType="XML"
            from="M357.45 390.7 C357.45,390.7 357.45,421.5 357.45,421.5 C357.45,421.5 388.95,421.5 388.95,421.5 C388.95,421.5 388.95,386.32 388.95,386.32 "
            to="M357.45 390.7 C357.45,390.7 357.45,421.5 357.45,421.5 C357.45,421.5 388.95,421.5 388.95,421.5 C388.95,421.5 388.95,386.32 388.95,386.32 "
            keyTimes="0;0.1333333;0.5466667;0.9333333;1"
            values="M357.45 390.7 C357.45,390.7 357.45,421.5 357.45,421.5 C357.45,421.5 388.95,421.5 388.95,421.5 C388.95,421.5 388.95,386.32 388.95,386.32 ;M367.45 390.7 C367.45,390.7 367.45,421.5 367.45,421.5 C367.45,421.5 398.95,421.5 398.95,421.5 C398.95,421.5 398.95,386.32 398.95,386.32 ;M297.45 390.7 C297.45,390.7 297.45,421.5 297.45,421.5 C297.45,421.5 328.95,421.5 328.95,421.5 C328.95,421.5 328.95,386.32 328.95,386.32 ;M357.45 390.7 C357.45,390.7 357.45,421.5 357.45,421.5 C357.45,421.5 388.95,421.5 388.95,421.5 C388.95,421.5 388.95,386.32 388.95,386.32 ;M357.45 390.7 C357.45,390.7 357.45,421.5 357.45,421.5 C357.45,421.5 388.95,421.5 388.95,421.5 C388.95,421.5 388.95,386.32 388.95,386.32 "
            keySplines="0.167 0 0.833 1;0.668 0 0 1;0.668 0 0 1;0 0 0 0"
            calcMode="spline"
          />
          <animate
            repeatCount="indefinite"
            dur="3s"
            begin="0s"
            xlink:href="#_R_G_L_6_G_D_1_P_0"
            fill="freeze"
            attributeName="d"
            attributeType="XML"
            from="M142.55 390.7 C142.55,390.7 142.55,421.5 142.55,421.5 C142.55,421.5 111.05,421.5 111.05,421.5 C111.05,421.5 111.05,386.32 111.05,386.32 "
            to="M142.55 390.7 C142.55,390.7 142.55,421.5 142.55,421.5 C142.55,421.5 111.05,421.5 111.05,421.5 C111.05,421.5 111.05,386.32 111.05,386.32 "
            keyTimes="0;0.1333333;0.5466667;0.9333333;1"
            values="M142.55 390.7 C142.55,390.7 142.55,421.5 142.55,421.5 C142.55,421.5 111.05,421.5 111.05,421.5 C111.05,421.5 111.05,386.32 111.05,386.32 ;M132.55 390.7 C132.55,390.7 132.55,421.5 132.55,421.5 C132.55,421.5 101.05,421.5 101.05,421.5 C101.05,421.5 101.05,386.32 101.05,386.32 ;M202.55 390.7 C202.55,390.7 202.55,421.5 202.55,421.5 C202.55,421.5 171.05,421.5 171.05,421.5 C171.05,421.5 171.05,386.32 171.05,386.32 ;M142.55 390.7 C142.55,390.7 142.55,421.5 142.55,421.5 C142.55,421.5 111.05,421.5 111.05,421.5 C111.05,421.5 111.05,386.32 111.05,386.32 ;M142.55 390.7 C142.55,390.7 142.55,421.5 142.55,421.5 C142.55,421.5 111.05,421.5 111.05,421.5 C111.05,421.5 111.05,386.32 111.05,386.32 "
            keySplines="0.167 0 0.833 1;0.668 0 0 1;0.668 0 0 1;0 0 0 0"
            calcMode="spline"
          />
          <animate
            repeatCount="indefinite"
            dur="3s"
            begin="0s"
            xlink:href="#_R_G_L_6_G_D_2_P_0"
            fill="freeze"
            attributeName="d"
            attributeType="XML"
            from="M388.15 264.89 C388.15,264.89 388.15,242.46 388.15,242.46 C388.15,224.44 373.54,209.83 355.52,209.83 C355.52,209.83 144.48,209.83 144.48,209.83 C126.46,209.83 111.85,224.44 111.85,242.46 C111.85,242.46 111.85,264.89 111.85,264.89 "
            to="M388.15 264.89 C388.15,264.89 388.15,242.46 388.15,242.46 C388.15,224.44 373.54,209.83 355.52,209.83 C355.52,209.83 144.48,209.83 144.48,209.83 C126.46,209.83 111.85,224.44 111.85,242.46 C111.85,242.46 111.85,264.89 111.85,264.89 "
            keyTimes="0;0.1333333;0.5466667;0.9333333;1"
            values="M388.15 264.89 C388.15,264.89 388.15,242.46 388.15,242.46 C388.15,224.44 373.54,209.83 355.52,209.83 C355.52,209.83 144.48,209.83 144.48,209.83 C126.46,209.83 111.85,224.44 111.85,242.46 C111.85,242.46 111.85,264.89 111.85,264.89 ;M398.15 264.89 C398.15,264.89 398.15,242.46 398.15,242.46 C398.15,224.44 383.54,209.83 365.52,209.83 C365.52,209.83 134.48,209.83 134.48,209.83 C116.46,209.83 101.85,224.44 101.85,242.46 C101.85,242.46 101.85,264.89 101.85,264.89 ;M328.15 264.89 C328.15,264.89 328.15,242.46 328.15,242.46 C328.15,224.44 313.54,209.83 295.52,209.83 C295.52,209.83 204.48,209.83 204.48,209.83 C186.46,209.83 171.85,224.44 171.85,242.46 C171.85,242.46 171.85,264.89 171.85,264.89 ;M388.15 264.89 C388.15,264.89 388.15,242.46 388.15,242.46 C388.15,224.44 373.54,209.83 355.52,209.83 C355.52,209.83 144.48,209.83 144.48,209.83 C126.46,209.83 111.85,224.44 111.85,242.46 C111.85,242.46 111.85,264.89 111.85,264.89 ;M388.15 264.89 C388.15,264.89 388.15,242.46 388.15,242.46 C388.15,224.44 373.54,209.83 355.52,209.83 C355.52,209.83 144.48,209.83 144.48,209.83 C126.46,209.83 111.85,224.44 111.85,242.46 C111.85,242.46 111.85,264.89 111.85,264.89 "
            keySplines="0.167 0 0.833 1;0.668 0 0 1;0.668 0 0 1;0 0 0 0"
            calcMode="spline"
          />
          <animate
            repeatCount="indefinite"
            dur="3s"
            begin="0s"
            xlink:href="#_R_G_L_6_G_D_3_P_0"
            fill="freeze"
            attributeName="d"
            attributeType="XML"
            from="M369.67 283.1 C369.67,283.1 369.67,354.27 369.67,354.27 C369.67,354.27 130.33,354.27 130.33,354.27 C130.33,354.27 130.33,283.1 130.33,283.1 C130.33,273.04 122.18,264.89 112.12,264.89 C112.12,264.89 112.12,264.89 112.12,264.89 C102.06,264.89 93.9,273.04 93.9,283.1 C93.9,283.1 93.9,355.38 93.9,355.38 C93.9,374.89 109.71,390.7 129.22,390.7 C129.22,390.7 370.78,390.7 370.78,390.7 C390.29,390.7 406.1,374.89 406.1,355.38 C406.1,355.38 406.1,283.1 406.1,283.1 C406.1,273.04 397.94,264.89 387.88,264.89 C387.88,264.89 387.88,264.89 387.88,264.89 C377.82,264.89 369.67,273.04 369.67,283.1z "
            to="M369.67 283.1 C369.67,283.1 369.67,354.27 369.67,354.27 C369.67,354.27 130.33,354.27 130.33,354.27 C130.33,354.27 130.33,283.1 130.33,283.1 C130.33,273.04 122.18,264.89 112.12,264.89 C112.12,264.89 112.12,264.89 112.12,264.89 C102.06,264.89 93.9,273.04 93.9,283.1 C93.9,283.1 93.9,355.38 93.9,355.38 C93.9,374.89 109.71,390.7 129.22,390.7 C129.22,390.7 370.78,390.7 370.78,390.7 C390.29,390.7 406.1,374.89 406.1,355.38 C406.1,355.38 406.1,283.1 406.1,283.1 C406.1,273.04 397.94,264.89 387.88,264.89 C387.88,264.89 387.88,264.89 387.88,264.89 C377.82,264.89 369.67,273.04 369.67,283.1z "
            keyTimes="0;0.1333333;0.5466667;0.9333333;1"
            values="M369.67 283.1 C369.67,283.1 369.67,354.27 369.67,354.27 C369.67,354.27 130.33,354.27 130.33,354.27 C130.33,354.27 130.33,283.1 130.33,283.1 C130.33,273.04 122.18,264.89 112.12,264.89 C112.12,264.89 112.12,264.89 112.12,264.89 C102.06,264.89 93.9,273.04 93.9,283.1 C93.9,283.1 93.9,355.38 93.9,355.38 C93.9,374.89 109.71,390.7 129.22,390.7 C129.22,390.7 370.78,390.7 370.78,390.7 C390.29,390.7 406.1,374.89 406.1,355.38 C406.1,355.38 406.1,283.1 406.1,283.1 C406.1,273.04 397.94,264.89 387.88,264.89 C387.88,264.89 387.88,264.89 387.88,264.89 C377.82,264.89 369.67,273.04 369.67,283.1z ;M379.67 283.1 C379.67,283.1 379.67,354.27 379.67,354.27 C379.67,354.27 120.33,354.27 120.33,354.27 C120.33,354.27 120.33,283.1 120.33,283.1 C120.33,273.04 112.18,264.89 102.12,264.89 C102.12,264.89 102.12,264.89 102.12,264.89 C92.06,264.89 83.9,273.04 83.9,283.1 C83.9,283.1 83.9,355.38 83.9,355.38 C83.9,374.89 99.71,390.7 119.22,390.7 C119.22,390.7 380.78,390.7 380.78,390.7 C400.29,390.7 416.1,374.89 416.1,355.38 C416.1,355.38 416.1,283.1 416.1,283.1 C416.1,273.04 407.94,264.89 397.88,264.89 C397.88,264.89 397.88,264.89 397.88,264.89 C387.82,264.89 379.67,273.04 379.67,283.1z ;M309.67 283.1 C309.67,283.1 309.67,354.27 309.67,354.27 C309.67,354.27 190.33,354.27 190.33,354.27 C190.33,354.27 190.33,283.1 190.33,283.1 C190.33,273.04 182.18,264.89 172.12,264.89 C172.12,264.89 172.12,264.89 172.12,264.89 C162.06,264.89 153.9,273.04 153.9,283.1 C153.9,283.1 153.9,355.38 153.9,355.38 C153.9,374.89 169.71,390.7 189.22,390.7 C189.22,390.7 310.78,390.7 310.78,390.7 C330.29,390.7 346.1,374.89 346.1,355.38 C346.1,355.38 346.1,283.1 346.1,283.1 C346.1,273.04 337.94,264.89 327.88,264.89 C327.88,264.89 327.88,264.89 327.88,264.89 C317.82,264.89 309.67,273.04 309.67,283.1z ;M369.67 283.1 C369.67,283.1 369.67,354.27 369.67,354.27 C369.67,354.27 130.33,354.27 130.33,354.27 C130.33,354.27 130.33,283.1 130.33,283.1 C130.33,273.04 122.18,264.89 112.12,264.89 C112.12,264.89 112.12,264.89 112.12,264.89 C102.06,264.89 93.9,273.04 93.9,283.1 C93.9,283.1 93.9,355.38 93.9,355.38 C93.9,374.89 109.71,390.7 129.22,390.7 C129.22,390.7 370.78,390.7 370.78,390.7 C390.29,390.7 406.1,374.89 406.1,355.38 C406.1,355.38 406.1,283.1 406.1,283.1 C406.1,273.04 397.94,264.89 387.88,264.89 C387.88,264.89 387.88,264.89 387.88,264.89 C377.82,264.89 369.67,273.04 369.67,283.1z ;M369.67 283.1 C369.67,283.1 369.67,354.27 369.67,354.27 C369.67,354.27 130.33,354.27 130.33,354.27 C130.33,354.27 130.33,283.1 130.33,283.1 C130.33,273.04 122.18,264.89 112.12,264.89 C112.12,264.89 112.12,264.89 112.12,264.89 C102.06,264.89 93.9,273.04 93.9,283.1 C93.9,283.1 93.9,355.38 93.9,355.38 C93.9,374.89 109.71,390.7 129.22,390.7 C129.22,390.7 370.78,390.7 370.78,390.7 C390.29,390.7 406.1,374.89 406.1,355.38 C406.1,355.38 406.1,283.1 406.1,283.1 C406.1,273.04 397.94,264.89 387.88,264.89 C387.88,264.89 387.88,264.89 387.88,264.89 C377.82,264.89 369.67,273.04 369.67,283.1z "
            keySplines="0.167 0 0.833 1;0.668 0 0 1;0.668 0 0 1;0 0 0 0"
            calcMode="spline"
          />
          <animate
            repeatCount="indefinite"
            dur="3s"
            begin="0s"
            xlink:href="#_R_G_L_5_G_D_0_P_0"
            fill="freeze"
            attributeName="d"
            attributeType="XML"
            from="M-119.67 4.71 C-119.67,4.71 -119.67,4.71 -119.67,4.71 C-119.67,-13.76 -104.7,-28.73 -86.23,-28.73 C-86.23,-28.73 86.23,-28.73 86.23,-28.73 C104.7,-28.73 119.67,-13.76 119.67,4.71 C119.67,4.71 119.67,4.71 119.67,4.71 C119.67,4.71 119.67,28.73 119.67,28.73 C119.67,28.73 -119.67,28.73 -119.67,28.73 C-119.67,28.73 -119.67,4.71 -119.67,4.71z "
            to="M-119.67 4.71 C-119.67,4.71 -119.67,4.71 -119.67,4.71 C-119.67,-13.76 -104.7,-28.73 -86.23,-28.73 C-86.23,-28.73 86.23,-28.73 86.23,-28.73 C104.7,-28.73 119.67,-13.76 119.67,4.71 C119.67,4.71 119.67,4.71 119.67,4.71 C119.67,4.71 119.67,28.73 119.67,28.73 C119.67,28.73 -119.67,28.73 -119.67,28.73 C-119.67,28.73 -119.67,4.71 -119.67,4.71z "
            keyTimes="0;0.1333333;0.5466667;0.9333333;1"
            values="M-119.67 4.71 C-119.67,4.71 -119.67,4.71 -119.67,4.71 C-119.67,-13.76 -104.7,-28.73 -86.23,-28.73 C-86.23,-28.73 86.23,-28.73 86.23,-28.73 C104.7,-28.73 119.67,-13.76 119.67,4.71 C119.67,4.71 119.67,4.71 119.67,4.71 C119.67,4.71 119.67,28.73 119.67,28.73 C119.67,28.73 -119.67,28.73 -119.67,28.73 C-119.67,28.73 -119.67,4.71 -119.67,4.71z ;M-129.67 4.71 C-129.67,4.71 -129.67,4.71 -129.67,4.71 C-129.67,-13.76 -114.7,-28.73 -96.23,-28.73 C-96.23,-28.73 96.23,-28.73 96.23,-28.73 C114.7,-28.73 129.67,-13.76 129.67,4.71 C129.67,4.71 129.67,4.71 129.67,4.71 C129.67,4.71 129.67,28.73 129.67,28.73 C129.67,28.73 -129.67,28.73 -129.67,28.73 C-129.67,28.73 -129.67,4.71 -129.67,4.71z ;M-59.67 4.71 C-59.67,4.71 -59.67,4.71 -59.67,4.71 C-59.67,-13.76 -44.7,-28.73 -26.23,-28.73 C-26.23,-28.73 26.23,-28.73 26.23,-28.73 C44.7,-28.73 59.67,-13.76 59.67,4.71 C59.67,4.71 59.67,4.71 59.67,4.71 C59.67,4.71 59.67,28.73 59.67,28.73 C59.67,28.73 -59.67,28.73 -59.67,28.73 C-59.67,28.73 -59.67,4.71 -59.67,4.71z ;M-119.67 4.71 C-119.67,4.71 -119.67,4.71 -119.67,4.71 C-119.67,-13.76 -104.7,-28.73 -86.23,-28.73 C-86.23,-28.73 86.23,-28.73 86.23,-28.73 C104.7,-28.73 119.67,-13.76 119.67,4.71 C119.67,4.71 119.67,4.71 119.67,4.71 C119.67,4.71 119.67,28.73 119.67,28.73 C119.67,28.73 -119.67,28.73 -119.67,28.73 C-119.67,28.73 -119.67,4.71 -119.67,4.71z ;M-119.67 4.71 C-119.67,4.71 -119.67,4.71 -119.67,4.71 C-119.67,-13.76 -104.7,-28.73 -86.23,-28.73 C-86.23,-28.73 86.23,-28.73 86.23,-28.73 C104.7,-28.73 119.67,-13.76 119.67,4.71 C119.67,4.71 119.67,4.71 119.67,4.71 C119.67,4.71 119.67,28.73 119.67,28.73 C119.67,28.73 -119.67,28.73 -119.67,28.73 C-119.67,28.73 -119.67,4.71 -119.67,4.71z "
            keySplines="0.167 0 0.833 1;0.668 0 0 1;0.668 0 0 1;0 0 0 0"
            calcMode="spline"
          />
          <animateMotion
            repeatCount="indefinite"
            dur="3s"
            begin="0s"
            xlink:href="#_R_G_L_3_G"
            fill="freeze"
            keyTimes="0;0.1333333;0.5466667;0.9333333;1"
            path="M312.18 253.32 C312.18,253.32 312.18,253.32 312.18,253.32 C301.82,253.32 250,253.32 250,253.32 C250,253.32 301.82,253.32 312.18,253.32 C312.18,253.32 312.18,253.32 312.18,253.32 "
            keyPoints="0;0;0.5;1;1"
            keySplines="0.668 0 0 1;0.668 0 0 1;0.668 0 0 1;0 0 0 0"
            calcMode="spline"
          />
          <animateTransform
            repeatCount="indefinite"
            dur="3s"
            begin="0s"
            xlink:href="#_R_G_L_3_G"
            fill="freeze"
            attributeName="transform"
            from="-312.179 -253.315"
            to="-312.179 -253.315"
            type="translate"
            additive="sum"
            keyTimes="0;1"
            values="-312.179 -253.315;-312.179 -253.315"
            keySplines="0 0 1 1"
            calcMode="spline"
          />
          <animateMotion
            repeatCount="indefinite"
            dur="3s"
            begin="0s"
            xlink:href="#_R_G_L_2_G"
            fill="freeze"
            keyTimes="0;0.1333333;0.5466667;0.9333333;1"
            path="M187.82 253.32 C187.82,253.32 187.82,253.32 187.82,253.32 C198.18,253.32 250,253.32 250,253.32 C250,253.32 198.18,253.32 187.82,253.32 C187.82,253.32 187.82,253.32 187.82,253.32 "
            keyPoints="0;0;0.5;1;1"
            keySplines="0.668 0 0 1;0.668 0 0 1;0.668 0 0 1;0 0 0 0"
            calcMode="spline"
          />
          <animateTransform
            repeatCount="indefinite"
            dur="3s"
            begin="0s"
            xlink:href="#_R_G_L_2_G"
            fill="freeze"
            attributeName="transform"
            from="-187.821 -253.315"
            to="-187.821 -253.315"
            type="translate"
            additive="sum"
            keyTimes="0;1"
            values="-187.821 -253.315;-187.821 -253.315"
            keySplines="0 0 1 1"
            calcMode="spline"
          />
          <animateTransform
            repeatCount="indefinite"
            dur="3s"
            begin="0s"
            xlink:href="#_R_G_L_0_G"
            fill="freeze"
            attributeName="transform"
            from="0"
            to="360"
            type="rotate"
            additive="sum"
            keyTimes="0;1"
            values="0;360"
            keySplines="0.167 0.167 0.833 0.833"
            calcMode="spline"
          />
          <animateTransform
            repeatCount="indefinite"
            dur="3s"
            begin="0s"
            xlink:href="#_R_G_L_0_G"
            fill="freeze"
            attributeName="transform"
            from="-5.955 -9.1"
            to="-5.955 -9.1"
            type="translate"
            additive="sum"
            keyTimes="0;1"
            values="-5.955 -9.1;-5.955 -9.1"
            keySplines="0 0 1 1"
            calcMode="spline"
          />
          <animate
            attributeType="XML"
            attributeName="opacity"
            dur="3s"
            from="0"
            to="1"
            xlink:href="#time_group"
          />
        </defs>
        <g id="_R_G">
          <g id="_R_G_L_10_G" transform="translate(195.84, 146.78)">
            <path
              id="_R_G_L_10_G_D_0_P_0"
              stroke="#202020"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
              stroke-width="8"
              stroke-opacity="1"
              d=" M58.17 28.94 C58.17,28.94 0.1,-29.13 0.1,-29.13 C0.1,-29.13 -58.17,29.13 -58.17,29.13 "
            />
          </g>
          <g id="_R_G_L_9_G_N_10_T_0" transform="translate(145.84, 146.78)">
            <g id="_R_G_L_9_G">
              <path
                id="_R_G_L_9_G_D_0_P_0"
                fill="#202020"
                fill-opacity="1"
                fill-rule="nonzero"
                d=" M -53.92 26.54  L -4.26 -26.54  L 48.82 26.54  Z "
              />
            </g>
          </g>
         
          <g
            id="_R_G_L_7_G"
            transform=" translate(177.686, 127.5) translate(0, 0)"
          >
            <path
              id="_R_G_L_7_G_D_0_P_0"
              stroke="#202020"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
              stroke-width="8"
              stroke-opacity="1"
              d=" M-83.79 49 C-83.79,49 83.79,49 83.79,49 C83.79,49 83.79,-49 83.79,-49 C83.79,-49 -83.79,-49 -83.79,-49 C-83.79,-49 -83.79,49 -83.79,49z "
            />
          </g>
          <g id="_R_G_L_6_G">
            <path
              id="_R_G_L_6_G_D_0_P_0"
              stroke="#202020"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
              stroke-width="8"
              stroke-opacity="1"
              d=" M357.45 390.7 C357.45,390.7 357.45,421.5 357.45,421.5 C357.45,421.5 388.95,421.5 388.95,421.5 C388.95,421.5 388.95,386.32 388.95,386.32 "
            />
            <path
              id="_R_G_L_6_G_D_1_P_0"
              stroke="#202020"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
              stroke-width="8"
              stroke-opacity="1"
              d=" M142.55 390.7 C142.55,390.7 142.55,421.5 142.55,421.5 C142.55,421.5 111.05,421.5 111.05,421.5 C111.05,421.5 111.05,386.32 111.05,386.32 "
            />
            <path
              id="_R_G_L_6_G_D_2_P_0"
              stroke="#202020"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
              stroke-width="8"
              stroke-opacity="1"
              d=" M388.15 264.89 C388.15,264.89 388.15,242.46 388.15,242.46 C388.15,224.44 373.54,209.83 355.52,209.83 C355.52,209.83 144.48,209.83 144.48,209.83 C126.46,209.83 111.85,224.44 111.85,242.46 C111.85,242.46 111.85,264.89 111.85,264.89 "
            />
            <path
              id="_R_G_L_6_G_D_3_P_0"
              stroke="#202020"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
              stroke-width="8"
              stroke-opacity="1"
              d=" M369.67 283.1 C369.67,283.1 369.67,354.27 369.67,354.27 C369.67,354.27 130.33,354.27 130.33,354.27 C130.33,354.27 130.33,283.1 130.33,283.1 C130.33,273.04 122.18,264.89 112.12,264.89 C112.12,264.89 112.12,264.89 112.12,264.89 C102.06,264.89 93.9,273.04 93.9,283.1 C93.9,283.1 93.9,355.38 93.9,355.38 C93.9,374.89 109.71,390.7 129.22,390.7 C129.22,390.7 370.78,390.7 370.78,390.7 C390.29,390.7 406.1,374.89 406.1,355.38 C406.1,355.38 406.1,283.1 406.1,283.1 C406.1,273.04 397.94,264.89 387.88,264.89 C387.88,264.89 387.88,264.89 387.88,264.89 C377.82,264.89 369.67,273.04 369.67,283.1z "
            />
          </g>
          <g
            id="_R_G_L_5_G"
            transform=" translate(250, 325.535) translate(0, 0)"
          >
            <path
              id="_R_G_L_5_G_D_0_P_0"
              stroke="#202020"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
              stroke-width="8"
              stroke-opacity="1"
              d=" M-119.67 4.71 C-119.67,4.71 -119.67,4.71 -119.67,4.71 C-119.67,-13.76 -104.7,-28.73 -86.23,-28.73 C-86.23,-28.73 86.23,-28.73 86.23,-28.73 C104.7,-28.73 119.67,-13.76 119.67,4.71 C119.67,4.71 119.67,4.71 119.67,4.71 C119.67,4.71 119.67,28.73 119.67,28.73 C119.67,28.73 -119.67,28.73 -119.67,28.73 C-119.67,28.73 -119.67,4.71 -119.67,4.71z "
            />
          </g>
          <g id="_R_G_L_4_G">
            <path
              id="_R_G_L_4_G_D_0_P_0"
              stroke="#202020"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
              stroke-width="8"
              stroke-opacity="1"
              d=" M244.44 247.75 C244.44,247.75 255.56,258.88 255.56,258.88 "
            />
            <path
              id="_R_G_L_4_G_D_1_P_0"
              stroke="#202020"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
              stroke-width="8"
              stroke-opacity="1"
              d=" M255.56 247.75 C255.56,247.75 244.44,258.88 244.44,258.88 "
            />
          </g>
          <g id="_R_G_L_3_G">
            <path
              id="_R_G_L_3_G_D_0_P_0"
              stroke="#202020"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
              stroke-width="8"
              stroke-opacity="1"
              d=" M306.62 247.75 C306.62,247.75 317.74,258.88 317.74,258.88 "
            />
            <path
              id="_R_G_L_3_G_D_1_P_0"
              stroke="#202020"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
              stroke-width="8"
              stroke-opacity="1"
              d=" M317.74 247.75 C317.74,247.75 306.62,258.88 306.62,258.88 "
            />
          </g>
          <g id="_R_G_L_2_G">
            <path
              id="_R_G_L_2_G_D_0_P_0"
              stroke="#202020"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
              stroke-width="8"
              stroke-opacity="1"
              d=" M193.38 247.75 C193.38,247.75 182.26,258.88 182.26,258.88 "
            />
            <path
              id="_R_G_L_2_G_D_1_P_0"
              stroke="#202020"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
              stroke-width="8"
              stroke-opacity="1"
              d=" M182.26 247.75 C182.26,247.75 193.38,258.88 193.38,258.88 "
            />
          </g>
          <g
            id="_R_G_L_1_G"
            transform=" translate(357.1, 127.5) translate(0, 0)"
          >
            <path
              id="_R_G_L_1_G_D_0_P_0"
              stroke="#202020"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
              stroke-width="8"
              stroke-opacity="1"
              d=" M0 49 C0,49 0,49 0,49 C27.06,49 49,27.06 49,0 C49,0 49,0 49,0 C49,-27.06 27.06,-49 0,-49 C0,-49 0,-49 0,-49 C-27.06,-49 -49,-27.06 -49,0 C-49,0 -49,0 -49,0 C-49,27.06 -27.06,49 0,49z "
            />
          </g>
          <g id="_R_G_L_0_G" transform=" translate(357.1, 127.5)">
            <path
              id="_R_G_L_0_G_D_0_P_0"
              stroke="#202020"
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="none"
              stroke-width="8"
              stroke-opacity="1"
              d=" M5.96 -9.1 C5.96,-9.1 5.96,9.1 5.96,9.1 C5.96,9.1 -5.95,9.1 -5.95,9.1 "
            />
          </g>
        </g>
        <g id="time_group" />
      </svg>

      <span class="loading-text"
        >${this._text ? this._text : "Yükleniyor..."}</span
      >
    </div> `;
  }
}
